import { createRouter } from "@tanstack/react-router";
import { queryClient } from "../queryClient";
import { routeTree } from "@/routeTree.gen";

export const router = createRouter({
    routeTree,
    context: {
        queryClient,
    },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
});
